import { useMediaQuery } from '@mui/material';
import clsx from 'clsx';
import ScrollRestoration from 'components/ScrollRestoration';
import SplashScreen from 'components/SplashScreen';
import { TOKEN } from 'features/auth/constants';
import { getAuthToken } from 'features/auth/helpers';
import React, { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useMatch, useNavigate } from 'react-router-dom';
import { history } from 'routes/history';
import { getPath } from 'routes/router-paths';

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  history.navigate = navigate;
  history.location = location;

  const isBigScreen = useMediaQuery('(min-width:1280px)');
  const isWelcomePage = Boolean(useMatch(getPath('portalPage')));

  const refreshToken = getAuthToken(TOKEN.REFRESH_TOKEN);

  useEffect(() => {
    if (refreshToken) return;
    navigate(getPath('loginPage', location.pathname));
  }, [refreshToken, location.pathname, navigate]);

  return (
    <div
      className={clsx(
        'h-screen w-screen bg-white',
        'flex flex-col overflow-hidden',
        !isWelcomePage && 'drop-shadow-2xl',
        isBigScreen ? 'w-[calc(100vw-60rem)]' : 'z-10 w-[48rem]',
        isWelcomePage && !isBigScreen && 'drop-shadow-2xl'
      )}
    >
      <main
        className={clsx(
          !isWelcomePage
            ? 'h-[calc(100%-72px)] flex-1 overflow-y-auto overflow-x-hidden'
            : 'h-full'
        )}
      >
        <Suspense
          fallback={
            <ScrollRestoration>
              <SplashScreen fullScreen />
            </ScrollRestoration>
          }
        >
          <Outlet />
        </Suspense>
      </main>
    </div>
  );
};

export default MainLayout;
